import React from 'react';

const Footer = () => {
    return (
        <div className='text-center py-10 bg-slate-400'>
          <p className="text-xl">
            © Copyright 2020 Eduvide All rights reserved.
          </p>
        </div>
    );
};

export default Footer;